var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"padding":"50px 100px","box-sizing":"border-box"}},[_c('div',{staticClass:"titles"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticStyle:{"height":"auto"},domProps:{"innerHTML":_vm._s(_vm.text)}})])}
var staticRenderFns = []

export { render, staticRenderFns }